// extracted by mini-css-extract-plugin
export default {"labelsContainer":"drop_down_cell_labelsContainer__lI05y","label":"drop_down_cell_label__s7f09"};